/* Code generated with AutoHTML Plugin for Figma */
import { ID } from "@project/shared-types";
import { useMemo } from "react";
import { BlockBase } from "../../../blocks/BlockBase/BlockBase";
import { Link } from "../../../components/link/link";
import Title from "../../../components/texts/title";
import { _aligeText, _size, _sizeHeading, _style } from "../../../core/core";
import { useData } from "../../../entities/service/model/DataContext";
import { ServiceView } from "../../../entities/service/ui/ServiceCard";
import "./services.css";
interface ServicesProps {
  exclude_ids?: ID[];
  [key: string]: any;
}

export const Services: React.FC<ServicesProps> = ({
  exclude_ids = [],
  ...props
}) => {
  const { products } = useData();
  const filteredProducts = useMemo(() => {
    return products.filter((product) => !exclude_ids.includes(product.id));
  }, [products, exclude_ids]);

  return (
    <>
      {products && (
        <BlockBase>
          <Title type={_sizeHeading.h2} alige={_aligeText.center}>
            Популярные услуги
          </Title>

          <div className="services-body">
            <div className="services-items">
              {filteredProducts.map((preview) => (
                <ServiceView key={preview.id} service={preview}></ServiceView>
              ))}
            </div>
          </div>
          <Link
            size={_size.M}
            style={_style.secondary2}
            width={"100%"}
            link={"/uslugi/"}
          >
            В каталог
          </Link>
        </BlockBase>
      )}
    </>
  );
};
